// extracted by mini-css-extract-plugin
export var childrenContainer = "_aj-0";